/* eslint-disable no-restricted-globals */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-empty-pattern */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react/button-has-type */
/* eslint-disable object-shorthand */
import React, { useState } from 'react';
import { ToastContainer } from 'react-toastify';
import { useParams, withRouter } from 'react-router-dom';
import { isEmpty } from 'lodash';
import * as keys from '../../../../services/config/Keys';
import { useSubscribe } from '../../../../hooks/subscribe/mac/useSubscribe';
import useMac from '../../../../hooks/subscribe/mac/useMac';

const Account = () => {
  const { macid } = useParams();
  const { loading, user } = useMac(macid);
  const [autoDebit, setAutoDebit] = useState(true);
  const [paystackPlanCode, setPaystackPlanCode] = useState('');
  const [flutterwavePlanCode, setFlutterwavePlanCode] = useState('');

  const {
    subscribeForPlanWithFlutterWave,
    subscribeForPlanWithPaystack,
  } = useSubscribe();

  const [monthNum, setMonthNum] = useState('1');

  const payWithPaystack = (plan) => {
    subscribeForPlanWithPaystack(monthNum, plan, user.user);
  };

  const payWithRave = () => {
    subscribeForPlanWithFlutterWave(monthNum, user, user.user);
  };

  return (
    <div className="text-center">
      <span className="sub_text font_22">Current Plan</span>
      <div className="row justify-content-center align-items-center">
        {loading ? (
          <small>loading...</small>
        ) : !isEmpty(user) ? (
          <div className="col-md-7 col-xl-5 mb-4">
            <div className="card box shadow h-100 py-2">
              <div className="card-body">
                <div className="row col-auto align-items-center">
                  <div className="col-auto">
                    <div className=" text-center d-flex mb-0">
                      <div>
                        <img
                          src="images/residential.png"
                          alt="House"
                          className="mr-2 mt-3"
                        />
                      </div>
                      <div className="text-left">
                        <div className="font_18 text-wrap bolder_font margin_bottom">
                          {user.username}
                        </div>
                        <div className="form-group d-flex mb-0 pb-0">
                          <select
                            defaultValue={monthNum}
                            id="monthNum"
                            className="form-control form-control-sm mt-2 mr-3"
                            onChange={(e) => setMonthNum(e.target.value)}
                          >
                            <option value="1">1 Month</option>
                            <option value="2">2 Months</option>
                            <option value="3">3 Months</option>
                            <option value="6">6 Months (+ 1 month free)</option>
                            <option value="12">1 Year (+ 2 months free)</option>
                          </select>
                          <label
                            className="d-flex mt-3 lighter_font"
                            htmlFor="monthNum"
                          >
                            GH₵
                            <span className="ml-1">
                              {monthNum * user.monthly_subscription}
                            </span>
                          </label>
                        </div>
                        {/* <div className="custom-control custom-checkbox">
                          <label
                            htmlFor="autoDebit"
                            className="checkbox-inline mt-0 lighter_font text-nowrap"
                          >
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              checked={autoDebit}
                              id="autoDebit"
                              onChange={(e) => setAutoDebit(e.target.checked)}
                            />
                            <span
                              className={
                                monthNum !== '2' &&
                                user.monthly_subscription <= 250
                                  ? 'ml-1 custom-control-label'
                                  : 'd-none'
                              }
                            >
                              I want to be charged{' '}
                              {monthNum === '1'
                                ? 'monthly'
                                : monthNum === '3'
                                ? 'quarterly'
                                : monthNum === '6'
                                ? 'bi-annually'
                                : monthNum === '12'
                                ? 'yearly'
                                : null}
                            </span>
                          </label>
                        </div>
                      */}
                        </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row col-auto justify-content-center align-items-center">
                <div className="col-auto align-items-center py-3 mr-2 d-flex">
                  <div className="payChannel_text text-nowrap m-0 p-0 pr-1 mt-1">
                    Pay with:
                  </div>
                  <div className="btn-group btn-group-sm" role="group">
                    <button
                      className="btn btn-outline-success mr-1"
                      onClick={() => payWithRave(user.monthly_subscription)}
                    >
                      <img
                        alt="flutterwave logo"
                        src="images/flutterwave.png"
                        width="100px"
                      />
                    </button>
                    <button
                      className="btn btn-outline-success"
                      onClick={() => payWithPaystack(user.monthly_subscription)}
                    >
                      <img
                        alt="paystack logo"
                        src="images/paystack.png"
                        width="115px"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>
      <ToastContainer />
    </div>
  );
};

export default withRouter(Account);
